import { render, staticRenderFns } from "./EventCreateDuplicate.vue?vue&type=template&id=796de3f8&"
import script from "./EventCreateDuplicate.vue?vue&type=script&lang=js&"
export * from "./EventCreateDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796de3f8')) {
      api.createRecord('796de3f8', component.options)
    } else {
      api.reload('796de3f8', component.options)
    }
    module.hot.accept("./EventCreateDuplicate.vue?vue&type=template&id=796de3f8&", function () {
      api.rerender('796de3f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/steps/EventCreateDuplicate.vue"
export default component.exports